import React from "react";
import { Component } from "react";

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTabOpenNo: 1,
    };
  }
  render() {
    return (
      <div class="py-2">
        <ul class="list-reset flex  custom-tabs-r px-4">
          <li
            className={
              this.state.isTabOpenNo == 1
                ? "font-bold text-black  active tab-submenu-active "
                : "-mb-px mr-1 "
            }
            onClick={() => this.setState({ isTabOpenNo: 1 })}
          >
            <p className="tab-submenu px-4 fsize14">About</p>
          </li>
          <li
            className={
              this.state.isTabOpenNo == 2
                ? "font-bold text-black  active tab-submenu-active "
                : "-mb-px mr-1 "
            }
            onClick={() => this.setState({ isTabOpenNo: 2 })}
          >
            <p className="tab-submenu px-4 fsize14">Instructors</p>
          </li>
          <li
            className={
              this.state.isTabOpenNo == 3
                ? "font-bold text-black  active tab-submenu-active"
                : "-mb-px mr-1 "
            }
            onClick={() => this.setState({ isTabOpenNo: 3 })}
          >
            <p className="tab-submenu px-4 fsize14">Syllabus</p>
          </li>

          <li
            className={
              this.state.isTabOpenNo == 4
                ? "font-bold text-black  active tab-submenu-active"
                : "-mb-px mr-1 "
            }
            onClick={() => this.setState({ isTabOpenNo: 4 })}
          >
            <p className="tab-submenu px-4 fsize14">Enrollment Options</p>
          </li>
        </ul>
        <div className={this.state.isTabOpenNo == 1 ? " active" : "hidden"}>
          <p className="text424B5A fsize18 line-h30 mt-14">
            Indigenous Canada is a 12-lesson Massive Open Online Course (MOOC)
            from the Faculty of Native Studies that explores Indigenous
            histories and contemporary issues in Canada. From an Indigenous
            perspective, this course explores key issues facing Indigenous
            peoples today from a historical and critical perspective
            highlighting national and local Indigenous-settler relations. Topics
            for the 12 lessons include the fur trade and other exchange
            relationships, land claims and environmental impacts, legal systems
            and rights, political conflicts and alliances, Indigenous political
            activism, and contemporary Indigenous life, art and its expressions.
          </p>
        </div>
      </div>
    );
  }
}
export default Profile;
